import { EmailCenterDetailViewModel } from "./emailCenterDetail.viewModel";

export class SendEmailShipmentViewModel {
    title:string;
    body:any;
    nameFrom:string;
    infoShipments:EmailCenterDetailViewModel[];
}
